
import { TextField } from '@mui/material';
import Select from '@mui/material/Select';
import styled from '@emotion/styled';

export const CustomTextField = styled(TextField)({
  direction: "rtl",
  position: "relative",
  "&&": {
    direction: "rtl !important",
    marginBottom: "1rem",
    justifyContent: "flex-end",
    position: "relative",
    width: "100%",
    borderRadius: "15px"
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#a0a0a0",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgb(201, 126, 245)",
  },
  "& label": {
    left: "unset",
    right: "1.8rem",
    transformOrigin: "right",
    fontFamily: "'Yekan !important'",
    fontSize: "1.2rem",
  },
  "& legend": {
    fontFamily: "'Yekan !important'",
    textAlign: "right",
    fontSize: "1.2rem"
  },
  "&  .MuiFormHelperText-root.Mui-error": {
    textAlign: "right",
    fontFamily: "'Yekan !important'",
  },
  '& .MuiInputBase-input': {
    padding: "1rem",
    fontFamily: "'Yekan !important'",
  },
  '& .MuiFormLabel-asterisk': {
    color: "red"
  },
  "& fieldset": {
    borderRadius: "15px",
  },
  "&.MuiFilledInput-root": {
    borderRadius: '25px',
  },
  '& .MuiSelect-iconOutlined': {
    right: "unset",
    left: ".5rem",
  },
  '& .MuiOutlinedInput-multiline': {
    minHeight: "100px"
  },
  '& .MuiMenu-list': {
    borderRadius: "15px",
    direction: "rtl !important"
  },


})

export const CustomSelectInput = styled(Select)({
  direction: "rtl",
  position: "relative",
  "&&": {
    direction: "rtl !important",
    marginBottom: "1rem",
    justifyContent: "flex-end",
    position: "relative",
    width: "100%",
    borderRadius: "15px"
  },

  "&.MuiInputLabel-root.Mui-focused": {
    // color: colors.gray
  },
  "&& .MuiInputLabel-root": {
    // color: colors.gray,
    right: 0,
    left: "unset"
  },
  "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    // borderColor: colors.defaultGreen,
  },
  "& label": {
    left: "unset",
    right: "1.75rem",
    transformOrigin: "right",
    fontFamily: "'Yekan !important'",
    fontSize: ".8rem",
  },
  "& legend": {
    fontFamily: "'Yekan !important'",
    textAlign: "right",
    fontSize: "0.8rem"
  },
  "&  .MuiFormHelperText-root.Mui-error": {
    textAlign: "right",
    fontFamily: "'Yekan !important'",
  },
  '& .MuiInputBase-input': {
    fontFamily: "'Yekan !important'",
  },
  "& fieldset": {
    borderRadius: "15px",
  },
  "&.MuiFilledInput-root": {
    borderRadius: '15px',
  },
  '& .MuiSelect-iconOutlined': {
    right: "unset",
    left: ".5rem",
  },
  '& .MuiOutlinedInput-multiline': {
    minHeight: "100px"
  },
  '& .MuiMenu-list': {
    borderRadius: "15px",
    direction: "rtl !important"
  },

})